export default "__VITE_ASSET__Dgzt$M$B__"